export default __webpack_public_path__ + "static/media/student.a444f536.png";